import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { SocioEmotionalSuggestionProgressByLevel } from './school-socio-emotional-dashboard-suggestions.models';

const SOCIO_EMOTIONAL_SUGGESTION_PROGRESS_ENDPOINT = 'api/socioEmotionalSuggestionProgress/school/';
@Component({
  selector: 'app-school-socio-emotional-dashboard-suggestions',
  templateUrl: './school-socio-emotional-dashboard-suggestions.component.html',
  styleUrls: ['./school-socio-emotional-dashboard-suggestions.component.scss']
})
export class SchoolSocioEmotionalDashboardSuggestionsComponent implements OnInit {
  isLoading = true;
  progressByLevel: SocioEmotionalSuggestionProgressByLevel[] = [];

  schoolId = localStorage.getItem('schoolId') || '';

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadProgressData();
  }

  private loadProgressData(): void {
    this.apiService.get({
      api: `${SOCIO_EMOTIONAL_SUGGESTION_PROGRESS_ENDPOINT}${this.schoolId}`
    }).subscribe({
      next: (res: SocioEmotionalSuggestionProgressByLevel[]) => {
        this.progressByLevel = res;
        this.isLoading = false;
      },
      error: (err) => {
        console.error('Error loading suggestion progress:', err);
        this.isLoading = false;
      }
    });
  }
}
